// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(true);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".hidden {\n  display: none !important; }\n", "",{"version":3,"sources":["webpack://src/pages/CustomerList/style.scss"],"names":[],"mappings":"AAAA;EACI,wBAAsB,EAAA","sourcesContent":[".hidden{\n    display:none!important;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
